// .env file values
export const secureSecretkey = process.env.REACT_APP_SECURE_SECRET_KEY;

// Constants Values
export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const restaurantName = "Zaiqa QR Menu";
export const userRoles = [
  "Admin",
  "Restaurant Owner",
  "Restaurant Manager",
  "Waiter",
  "Chef",
];
export const ADMINUSER = userRoles[0];
export const RESTAURANTOWNERUSER = userRoles[1];
export const RESTAURANTMANAGERUSER = userRoles[2];
export const WAITERUSER = userRoles[3];
export const CHEFUSER = userRoles[4];
export const subscribedPlanArr = ["Basic", "Premium", "Pro"];
export const BASICPLAN = subscribedPlanArr[0];
export const PREMIUMPLAN = subscribedPlanArr[1];
export const PROPLAN = subscribedPlanArr[2];
const sliceStatus = [
  "idle",
  "loading",
  "success",
  "succeeded",
  "failed",
  "error",
];
export const IDLESTATUS = sliceStatus[0];
export const LOADINGSTATUS = sliceStatus[1];
export const SUCCESSSTATUS = sliceStatus[2];
export const FAILEDSTATUS = sliceStatus[4];
export const ERRORSTATUS = sliceStatus[5];
export const TABLE = "table"
export const PARCEL = "parcel"
export const ORDEREDSTATUS = "Ordered"
export const COOKINGTATUS = "Cooking"
export const READYSTATUS = "Ready"
export const ONTABLESTATUS = "On Table"
export const REJECTEDSTATUS = "Rejected"

// Existing Category Options - Total 38 Categories
export const existingCategory = [
  {
    categoryName: "Select Category",
    categoryPhotoURL: "",
  },
  {
    categoryName: "Water Bottles and Cold Drinks",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053193/Water_Bottles_and_Cold_Drinks_t8lp03.webp",
  },
  {
    categoryName: "Hot Coffee",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053196/Hot_Coffee_qyy4mc.webp",
  },
  {
    categoryName: "Cold Coffee",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053195/Cold_Coffee_aqb4mm.avif",
  },
  {
    categoryName: "Filter Coffee",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053195/Filter_Coffee_ypfchn.jpg",
  },
  {
    categoryName: "Tea",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053432/Tea_dywex5.jpg",
  },
  {
    categoryName: "Mocktails",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053432/Tea_dywex5.jpg",
  },
  {
    categoryName: "Mojito",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053199/Mojito_aweycw.webp",
  },
  {
    categoryName: "Shakes",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053191/Shakes_lglm2z.avif",
  },
  {
    categoryName: "Breads",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053194/Breads_yuwfd2.jpg",
  },
  {
    categoryName: "Fries",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053195/Fries_vslmdz.jpg",
  },
  {
    categoryName: "Croissant",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053194/croissant_a6hdag.jpg",
  },
  {
    categoryName: "Garlic Bread and Toast",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053196/Garlic_Bread_and_Toast_kchimt.jpg",
  },
  {
    categoryName: "Nachos",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053197/Nachos_hqyvph.webp",
  },
  {
    categoryName: "Appetizer",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053193/Appetizer_vr8v52.jpg",
  },
  {
    categoryName: "Pasta",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053192/Pasta_wnj9n1.avif",
  },
  {
    categoryName: "Pizza",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053192/Pizza_w10ftv.jpg",
  },
  {
    categoryName: "Sandwiches",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053192/Sandwiches_jwgvzp.jpg",
  },
  {
    categoryName: "Burgers",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053194/Burgers_lwuuvd.avif",
  },
  {
    categoryName: "Maggie",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053196/Maggie_ntlqoc.jpg",
  },
  {
    categoryName: "Salad",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053193/Salad_zzbmxb.webp",
  },
  {
    categoryName: "Soup",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053192/Soup_fli8te.jpg",
  },
  {
    categoryName: "Rice & Bowl",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053192/Rice_Bowl_w0n5uf.jpg",
  },
  {
    categoryName: "Dal",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053196/Dal_qs4f2s.webp",
  },
  {
    categoryName: "Noodles",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053197/Noodles_bqoxw6.jpg",
  },
  {
    categoryName: "Briyani",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053194/Briyani_idpqqh.jpg",
  },
  {
    categoryName: "Veg Starters",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053193/Veg_Starters_iqhxau.avif",
  },
  {
    categoryName: "Chinese Starters",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053193/Chinese_Starters_iswhhj.jpg",
  },
  {
    categoryName: "Mutton Starters",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053197/Mutton_Starters_grpma3.jpg",
  },
  {
    categoryName: "Fish Starters",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053195/Fish_Starters_xuaiuv.avif",
  },
  {
    categoryName: "Prawns Starters",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053192/Prawns_Starters_f6fxtn.jpg",
  },
  {
    categoryName: "Veg Platters",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053194/Veg_Platters_bliy7e.png",
  },
  {
    categoryName: "Non-Veg Platters",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053198/Non-Veg_Platters_pvk9ff.jpg",
  },
  {
    categoryName: "Veg Main Course",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053191/Veg_Main_Course_iilcdz.avif",
  },
  {
    categoryName: "Chicken Main Course",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053194/Chicken_Main_Course_lwot5o.jpg",
  },
  {
    categoryName: "Mutton Main Course",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053198/Mutton_Main_Course_cwqpia.jpg",
  },
  {
    categoryName: "Sea Food Main Course",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053191/Sea_Food_Main_Course_zhwxlf.jpg",
  },
  {
    categoryName: "Desert",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053195/Desert_uv7dl8.jpg",
  },
  {
    categoryName: "Add on",
    categoryPhotoURL:
      "https://res.cloudinary.com/dn5s57zk0/image/upload/v1772053193/Add_on_ksltrk.jpg",
  },
];

// Veg/Non-Veg and Egg Category Items Icons
export function GetVegIcon({ size = 16 }) {
  return (
    <svg
      className="food-icon ms-1"
      viewBox="0 0 100 100"
      width={size}
      height={size}
    >
      <rect
        x="5"
        y="5"
        width="90"
        height="90"
        rx="18"
        fill="#fff"
        stroke="#1b7f3a"
        strokeWidth="8"
      />
      <circle cx="50" cy="50" r="26" fill="#1b7f3a" />
    </svg>
  );
}

export function GetNonVegIcon({ size = 16 }) {
  return (
    <svg
      className="food-icon ms-1"
      viewBox="0 0 100 100"
      width={size}
      height={size}
    >
      <rect
        x="5"
        y="5"
        width="90"
        height="90"
        rx="18"
        fill="#fff"
        stroke="#c62828"
        strokeWidth="8"
      />
      <circle cx="50" cy="50" r="26" fill="#c62828" />
    </svg>
  );
}

export function GetEggIcon({ size = 16 }) {
  return (
    <svg
      className="food-icon ms-1"
      viewBox="0 0 100 100"
      width={size}
      height={size}
    >
      <rect
        x="5"
        y="5"
        width="90"
        height="90"
        rx="18"
        fill="#fff"
        stroke="#f9a825"
        strokeWidth="8"
      />
      <circle cx="50" cy="50" r="26" fill="#f9a825" />
    </svg>
  );
}

//Payment Options
export const paymentOptions = ["Cash", "Card", "UPI", "Other"];
